import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { XIcon, Sparkles } from 'lucide-react';
import { Button } from '../ui/Button';
import { useTranslation } from '../../lib/i18n';
export function PromoPopup() {
  const navigate = useNavigate();
  const [visible, setVisible] = useState(false);
  const [dismissed, setDismissed] = useState(false);
  const {
    t
  } = useTranslation();
  useEffect(() => {
    const timer = setTimeout(() => setVisible(true), 4000);
    return () => clearTimeout(timer);
  }, []);
  if (!visible || dismissed) return null;
  return <div className="fixed inset-0 z-50 flex items-center justify-center px-4 sm:px-6" data-id="element-277" data-mp="17rm4hvivv63l">
      {/* Backdrop */}
      <div className="absolute inset-0 bg-black/40 backdrop-blur-[1px] transition-opacity" onClick={() => setDismissed(true)} data-id="element-278" data-mp="1cpxdk41ctckr" />
      
      {/* Popup Container */}
      <div className="relative z-10 w-full max-w-lg transform overflow-hidden rounded-2xl bg-dark-bg border border-dark-border shadow-[0_0_50px_-12px_rgba(250,204,21,0.15)] transition-all" data-id="element-279" data-mp="1b0ee1bgh6zo">
        
        {/* Top Accent Line */}
        <div className="absolute top-0 left-0 right-0 h-1.5 bg-gradient-to-r from-brand-yellow/20 via-brand-yellow to-brand-yellow/20" data-id="element-280" data-mp="2961hoo9e3fpt" />
        
        {/* Subtle Background Glow */}
        <div className="absolute -top-24 -right-24 w-48 h-48 bg-brand-yellow/10 rounded-full blur-3xl pointer-events-none" data-id="element-281" data-mp="2i5esbk992ac4" />
        <div className="absolute -bottom-24 -left-24 w-48 h-48 bg-brand-yellow/5 rounded-full blur-3xl pointer-events-none" data-id="element-282" data-mp="2w44nuvgf81yd" />

        <div className="relative p-8 sm:p-10" data-id="element-283" data-mp="2s1rl8fwz0k5t">
          {/* Close Button */}
          <button onClick={() => setDismissed(true)} className="absolute top-4 right-4 p-2 text-gray-400 hover:text-white hover:bg-white/5 rounded-full transition-all" aria-label="Zatvori" data-id="element-284" data-mp="35ur1wl8hokey">
            <XIcon className="w-5 h-5" data-id="element-285" data-mp="3auc1mxvhgwsq" />
          </button>

          {/* Content */}
          <div className="flex flex-col items-center text-center mt-2" data-id="element-286" data-mp="3asipj323pkdc">
            
            {/* Badge */}
            <div className="inline-flex items-center gap-2 bg-brand-yellow/10 border border-brand-yellow/20 text-brand-yellow text-xs sm:text-sm font-black uppercase tracking-[0.2em] px-4 py-1.5 rounded-full mb-6" data-id="element-287" data-mp="3mwmsgb1qt6qd">
              <Sparkles className="w-4 h-4" data-id="element-288" data-mp="hk5vpcx6hj2" />
              {t.popup.badge}
            </div>

            {/* Title */}
            <h3 className="text-3xl sm:text-4xl font-black text-white leading-tight mb-4 tracking-tight" data-id="element-289" data-mp="5f3k4p9maub0">
              {t.popup.title}
            </h3>

            {/* Body */}
            <p className="text-lg sm:text-xl text-gray-300 font-medium leading-relaxed mb-8 max-w-[90%]" data-id="element-290" data-mp="egbi16881t4k">
              {t.popup.body}
            </p>

            {/* Date / Avans */}
            <div className="w-full py-4 px-6 bg-white/5 border border-white/10 rounded-xl mb-8" data-id="element-291" data-mp="2g8g44131hw7d">
              <p className="text-brand-yellow font-semibold text-sm sm:text-base" data-id="element-292" data-mp="2l79fnnyrnd4w">
                {t.popup.avans}
              </p>
            </div>

            {/* CTA */}
            <Button variant="primary" size="lg" className="w-full sm:w-auto min-w-[240px] shadow-[0_0_20px_-5px_rgba(250,204,21,0.4)] hover:shadow-[0_0_25px_-5px_rgba(250,204,21,0.6)] transition-all duration-300 transform hover:-translate-y-0.5" onClick={() => {
            setDismissed(true);
            navigate('/products');
          }} data-id="element-293" data-mp="2dpux1po7q0ru">
              {t.popup.btnPrimary}
            </Button>
          </div>
        </div>
      </div>
    </div>;
}